
















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import { FieldType, Filter, CompareType } from "../../../store/entities/filter";
import PageRequest from "../../../store/entities/page-request";
import CreateUser from "./create-user.vue";
import EditUser from "./edit-user.vue";
import FlowUser from "./flow-user.vue";
@Component({
  components: { CreateUser, EditUser, FlowUser }
})
export default class Users extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  flow() {
    this.flowModalShow = true;
  }
  filters: Filter[] = [
    {
      Type: FieldType.String,
      Value: "",
      FieldName: "UserName",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.String,
      Value: "",
      FieldName: "Name",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.DataRange,
      Value: "",
      FieldName: "CreationTime",
      CompareType: CompareType.Contains
    },
    {
      Type: FieldType.Boolean,
      Value: null,
      FieldName: "IsActive",
      CompareType: CompareType.Equal
    }
  ];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  flowModalShow: boolean = false;
  get list() {
    return this.$store.state.user.list;
  }
  get loading() {
    return this.$store.state.user.loading;
  }
  create() {
    this.createModalShow = true;
  }
  isActiveChange(val: string) {
    if (val === "Actived") {
      this.filters[3].Value = true;
    } else if (val === "NoActive") {
      this.filters[3].Value = false;
    } else {
      this.filters[3].Value = null;
    }
  }
  pageChange(page: number) {
    this.$store.commit("user/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("user/setPageSize", pagesize);
    this.getpage();
  }
  searchUser() {
    this.$store.commit("user/setCurrentPage", 1);
		this.getpage();
  }
  async getpage() {
    let where = Util.buildFilters(this.filters);
    let pagerequest = new PageRequest();
		pagerequest.maxResultCount = this.pageSize;
    pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    pagerequest.where = where;
    await this.$store.dispatch({
      type: "user/getAll",
      data: pagerequest
    });
  }
  get pageSize() {
    return this.$store.state.user.pageSize;
  }
  get totalCount() {
    return this.$store.state.user.totalCount;
  }
  get currentPage() {
    return this.$store.state.user.currentPage;
  }
  columns = [
    {
      title: "地区",
      key: "selectDistrict"
    },
    {
      title: "用户名",
      key: "userName"
    },
    {
      title: "姓名",
      key: "name"
    },
    {
      title: "职位",
      key: "position"
    },
    {
      title: "激活状态",
      render: (h: any, params: any) => {
        return h("span", params.row.isActive ? "已激活" : "未激活");
      }
    },
    {
      title: "创建时间",
      key: "creationTime",
      render: (h: any, params: any) => {
        if (params.row.creationTime) {
          return h(
            "span",
            new Date(
              params.row.creationTime.replace("T", " ")
            ).toLocaleDateString()
          );
        }
      }
    },
    {
      title: "上一次登录时间",
      render: (h: any, params: any) => {
        if (params.row.lastLoginTime) {
          return h(
            "span",
            new Date(
              params.row.lastLoginTime.replace("T", " ")
            ).toLocaleString()
          );
        }
      }
    },
    {
      title: "操作",
      key: "Actions",
      align: 'center',
      width: 180,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$store.commit("user/edit", params.row);
                  this.edit();
                }
              }
            },
            "编辑角色"
          ),
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              on: {
                click: () => {
                  this.$store.commit("user/edit", params.row);
                  this.flow();
                }
              }
            },
            "流程角色"
          ),
          // h(
          //   "Button",
          //   {
          //     props: {
          //       type: "error",
          //       size: "small"
          //     },
          //     on: {
          //       click: async () => {
          //         this.$Modal.confirm({
          //           title: "用户删除",
          //           content: "是否删除此用户",
          //           okText: "是",
          //           cancelText: "取消",
          //           onOk: async () => {
          //             await this.$store.dispatch({
          //               type: "user/delete",
          //               data: params.row
          //             });
          //             await this.getpage();
          //           }
          //         });
          //       }
          //     }
          //   },
          //   "删除"
          // )
        ]);
      }
    }
  ];
  async created() {
    this.getpage();
    await this.$store.dispatch({
      type: "user/getRoles"
		});
  }
}
